(function () {
  'use strict';
  if (window.mzCymSizeFit) return;
  window.mzCymSizeFit = true;

  var phone = window.matchMedia('(max-width: 749px)');
  var details = new Set();
  var queued = false;
  var observer = new ResizeObserver(schedule);

  function visibleWidth(element) {
    if (!element || element.classList.contains('visually-hidden')) return 0;
    return element.getBoundingClientRect().width;
  }

  function fit(detail) {
    var rating = detail.querySelector('.mz-cym-row__rating');
    if (!rating) return;
    var stars = rating.querySelector('.mz-cym-row__stars');
    if (!stars) return;
    delete rating.dataset.mzCymRatingFit;
    rating.style.removeProperty('--mz-cym-fit-star-size');
    if (!phone.matches) return;

    var style = getComputedStyle(detail);
    var ratingStyle = getComputedStyle(rating);
    var maximum = parseFloat(ratingStyle.fontSize);
    var minimum = parseFloat(ratingStyle.getPropertyValue('--mz-cym-rating-min-star-size'));
    var gap = parseFloat(ratingStyle.columnGap) || 0;
    var size = detail.querySelector('.mz-cym-row__size');
    var available = detail.getBoundingClientRect().width - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
    if (size) available -= size.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
    var unitWidth = stars.getBoundingClientRect().width / maximum;
    var countWidth = visibleWidth(rating.querySelector('.mz-cym-row__rating-count'));
    var averageWidth = visibleWidth(rating.querySelector('.mz-cym-row__rating-value'));
    var mode = 'full';
    if (!(maximum > 0 && minimum > 0 && unitWidth > 0)) {
      rating.dataset.mzCymRatingFit = 'stars-hidden';
      return;
    }
    minimum = Math.min(minimum, maximum);

    function starSize() {
      var gaps = (countWidth > 0 ? 1 : 0) + (averageWidth > 0 ? 1 : 0);
      return (available - countWidth - averageWidth - gap * gaps) / unitWidth;
    }

    var chosen = starSize();
    if (chosen < minimum) {
      countWidth = 0;
      mode = 'count-hidden';
      chosen = starSize();
    }
    if (chosen < minimum && averageWidth > 0) {
      averageWidth = 0;
      mode = 'average-hidden';
      chosen = starSize();
    }
    if (chosen < minimum) {
      rating.dataset.mzCymRatingFit = 'stars-hidden';
      return;
    }
    rating.style.setProperty('--mz-cym-fit-star-size', Math.min(maximum, chosen) + 'px');
    rating.dataset.mzCymRatingFit = mode;
  }

  function flush() {
    queued = false;
    details.forEach(function (detail) {
      if (!detail.isConnected) {
        observer.unobserve(detail);
        details.delete(detail);
      } else {
        fit(detail);
      }
    });
  }

  function schedule() {
    if (!queued) {
      queued = true;
      requestAnimationFrame(flush);
    }
  }

  function collect(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    var found = Array.from(root.querySelectorAll('.mz-cym-row__details'));
    if (root.matches && root.matches('.mz-cym-row__details')) found.push(root);
    found.forEach(function (detail) {
      if (!details.has(detail)) {
        details.add(detail);
        observer.observe(detail);
      }
    });
    schedule();
  }

  function start() {
    collect(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(collect);
      });
      schedule();
    }).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function (event) { collect(event.target); });
    phone.addEventListener('change', schedule);
    if (document.fonts) {
      document.fonts.ready.then(schedule);
      document.fonts.addEventListener('loadingdone', schedule);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
